import { useMemo } from "react";
import { Responsive, WidthProvider } from "react-grid-layout";
import styled from "styled-components";
import { useBSDashboardContext } from "../../hooks/useBSDashboardContext";
import {
  arrangeWidgets,
  breakpoints,
  createLayoutConfiguration,
  widgetIdSplitSymbol,
} from "../../../../helpers/gridLayoutConfigurations";
import LazyBSWidgetLoader from "../lazyBSWidgetLoader";
import { media } from "../../../../helpers/responsive";

const BSWidgetsGridLayout = () => {
  const { widgetsList } = useBSDashboardContext();

  const columns = { xxl: 3, xl: 3, lg: 2, md: 2, sm: 2, xs: 1, xxs: 1 };

  const gridConfiguration = useMemo(() => {
    if (!widgetsList.length) {
      return null;
    }
    let widgetIds = widgetsList.map(
      (d) => `${d.url}${widgetIdSplitSymbol}${d.type}`
    );
    let gridConfig = arrangeWidgets(
      createLayoutConfiguration({
        bp: breakpoints,
        items: widgetIds,
      }),
      columns
    );
    return gridConfig;
  }, [JSON.stringify(widgetsList)]);

  return (
    <Wrapper>
      {gridConfiguration ? (
        <GridLayout
          breakpoints={breakpoints}
          rowHeight={25}
          allowOverlap={false}
          verticalCompact
          cols={columns}
          isResizable={false}
          isDraggable={false}
          containerPadding={{
            xxl: [30, 15],
            xl: [30, 15],
            lg: [30, 15],
            md: [10, 15],
            sm: [15, 15],
            xs: [10, 10],
            xxs: [8, 8],
          }}
          layouts={gridConfiguration}
          margin={[25, 25]}>
          {widgetsList.map((w, index) => (
            <div key={`${w.url}${widgetIdSplitSymbol}${w.type}`}>
              <LazyBSWidgetLoader widget={w} />
            </div>
          ))}
        </GridLayout>
      ) : null}
    </Wrapper>
  );
};
export default BSWidgetsGridLayout;

const Wrapper = styled.div``;

const GridLayout = styled(WidthProvider(Responsive))`
  margin: 25px 10px 20px 10px;
  .react-grid-item.react-grid-placeholder {
    background: grey;
    border-radius: 20px;
  }

  ${media.down.xs} {
    margin: 10px 5px 10px 5px;
  }
`;
